<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import SearchInfluencers from "@/components/searchInfluencers";

export default {
  page: {
    title: "Influencers",
  },
  components: {SearchInfluencers, Layout, PageHeader},
  data() {
    return {
      title: "Search for influencers",
    };
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title"/>

    <search-influencers></search-influencers>
  </Layout>
</template>
